{
  "required": "This field is required.",
  "tooShort": "Must be at least {min} characters.",
  "tooLong": "Must be {max} characters or fewer.",
  "invalidEmail": "Enter a valid email address.",
  "invalidNumber": "Enter a valid number.",
  "minAmount": "Enter at least {amount}."
}
